<script>
import Vue from 'vue'
import { bApp, termsBtnText } from 'base/config'
import Sliding from 'base/sliding/sliding'
import ListView from 'base/listview/listview'
import { clause, liabilities } from 'api/index'
import { pbfUrl } from 'api/config'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview, {
  loop: false,
  fullscreenEl: false,
  zoomEl: false
})

const pbfSearchBase = `${pbfUrl}/planBook/termsSearch/pages`

export default {
  name: 'TermsEnter',
  components: {
    Sliding,
    ListView
  },
  props: {
    propUuid: {
      type: String
    },
    propName: {
      type: String,
      default: ''
    }
  },
  data() {
    this.isApp = bApp
    this.btnText = termsBtnText
    this.searchUrl = `${pbfSearchBase}/index.html?nw=1`
    return {
      terms: {
        show: false,
        list: []
      },
      termsDetailList: [],
      termsListShow: []
    }
  },
  computed: {
    codeVisible() {
      const { terms } = this
      if (!Array.isArray(terms.list)) return
      const codeList = terms.list.filter(item => {
        return item.code
      })
      return !!codeList.length
    }
  },
  watch: {
    propUuid: {
      handler() {
        this.terms.list = []
      }
    }
  },
  created() {
    // this._initList()
  },
  mounted() {
    this.$previewRefresh()
  },
  methods: {
    handleOpen({ item, index } = {}) {
      const { termsListShow, termsDetailList } = this
      if (termsListShow[index]) {
        this.termsListShow.splice(index, 1, false)
        return
      }
      if (termsDetailList[index]) {
        this.termsListShow.splice(index, 1, true)
        return
      }

      liabilities({}, `${item.id}/liabilities`).then(
        ({ data: { success, data } } = { data: {} }) => {
          if (success) {
            this.termsDetailList.splice(index, 1, data)
            this.termsListShow.splice(index, 1, true)
            this.$nextTick(() => {
              this.$previewRefresh()
            })
          }
        }
      )
    },
    handleShowImg(list, idx) {
      if (appBridge && appBridge.checkAppFeature('NATIVE_IMAGE_VIEWER')) {
        const urls = list.map(item => {
          return item.picUrl
        })
        appBridge.showImageViewer({ urls, idx }).catch(function(e) {
          console.log(e.name + '  ' + e.message)
        })
      }
    },
    _clauseAjax() {
      let {
        propUuid,
        terms: { list }
      } = this

      if (list.length === 0 && propUuid) {
        clause({ uuid: propUuid }).then(
          ({ data: { success, data } } = { data: {} }) => {
            if (success) {
              const _data = this._transformData(data)
              const _len = _data.length
              this.terms.list = _data
              this.termsListShow.length = _len
              this.termsDetailList.length = _len
              this.$nextTick(() => {
                this.terms.show = true
              })
            }
          }
        )
      } else {
        this.terms.show = true
      }
    },
    _transformData(ary) {
      if (!Array.isArray(ary) || !ary.length) return []
      let { propName } = this
      ary.forEach((item, index) => {
        if (item) {
          ary[index].href = `${pbfSearchBase}/terms.html?termsId=${
            item.id
          }&nw=1${propName ? '&name=' + encodeURIComponent(propName) : ''}`
        } else {
          ary.splice(index)
        }
      })
      return ary
    }
  }
}
</script>

<template>
  <div class="terms-wrap">
    <a
      class="btn"
      href="javascript:;"
      data-stat-id="tkxq"
      @click="_clauseAjax"
    >{{ btnText }}</a>
    <sliding
      :show="terms.show"
      :over-height="false"
      :title="'条款列表'"
      iconfont="icon-close_line"
      @close="terms.show = false"
    >
      <div class="terms-container">
        <list-view
          class="terms-list"
          :list-data="terms.list"
          :class="{ 'no-code': !codeVisible }"
        >
          <!-- <template slot="item" slot-scope="props">
            <li class='after-bd-b'>
              <a class="link cell-box"
                :title="props.item.name"
                :href="props.item.href"
                data-stat-id="list"
                :data-stat-ep="JSON.stringify({id: props.item.id})">
                <div class="pre-wrap">
                  <div class="pre">{{props.item.code}}</div>
                </div>
                <div class="info-wrap assert-r">
                  <div class="info">
                    <h4>
                      <span class="name">{{props.item.fullName}}</span>
                    </h4>
                  </div>
                </div>
              </a>
            </li>
          </template> -->
          <template slot="item" slot-scope="props">
            <li class="after-bd-b">
              <div
                class="link cell-box"
                data-stat-id="list"
                :data-stat-ep="JSON.stringify({ id: props.item.id })"
                @click="handleOpen(props)"
              >
                <div class="pre-wrap">
                  <div class="pre">
                    {{ props.item.code || ' - -' }}
                  </div>
                </div>
                <div
                  class="info-wrap"
                  :class="[
                    termsListShow[props.index] ? 'assert-t' : 'assert-b'
                  ]"
                >
                  <div class="info">
                    <h4>
                      <span class="name">{{ props.item.fullName }}</span>
                    </h4>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  termsListShow[props.index] &&
                    (props.item.clauseUrl ||
                      termsDetailList[props.index].length)
                "
                class="liabilities-pic"
              >
                <div
                  v-if="termsListShow[props.index] && props.item.clauseUrl"
                  class="original-link"
                >
                  <a
                    :title="props.item.name"
                    data-stat-id="tkxq_yw"
                    :href="`${props.item.clauseUrl}?nw=1`"
                  >
                    <h6>条款预览</h6>
                    <div class="view assert-r">查看条款原文</div>
                  </a>
                </div>
                <template
                  v-if="
                    termsListShow[props.index] &&
                      termsDetailList[props.index].length
                  "
                >
                  <template v-if="isApp">
                    <div
                      v-for="(pic, index) in termsDetailList[props.index]"
                      :key="Math.random()"
                      class="liab-img"
                      @click="
                        handleShowImg(termsDetailList[props.index], index)
                      "
                    >
                      <img :src="pic.picUrl" :alt="pic.id">
                      <i class="zoom-in" />
                    </div>
                  </template>
                  <template v-else>
                    <div
                      v-for="(pic, index) in termsDetailList[props.index]"
                      :key="Math.random()"
                      class="liab-img"
                    >
                      <img
                        :src="pic.picUrl"
                        :alt="pic.id"
                        :preview="props.index"
                        :large="pic.picUrl"
                      >
                      <i class="zoom-in" />
                    </div>
                  </template>
                </template>
              </div>
            </li>
          </template>
          <template v-if="isApp" slot="aftItem">
            <li class="more">
              <a :href="searchUrl" data-stat-id="more">
                <span class="assert-r">搜索更多条款</span>
              </a>
            </li>
          </template>
        </list-view>
      </div>
    </sliding>
  </div>
</template>

<style scoped>
@import 'variable';

.terms-wrap {
  @apply --widthcenter;
  margin-bottom: 10px;
  border-radius: 6px;
  background-color: var(--white-color);
  .btn {
    display: block;
    padding: 12px 0;
    text-align: center;
    color: var(--thre-color);
    font-weight: bold;
    font-size: 17px;
  }
}

.terms-list {
  > li {
    overflow: hidden;
    &:after {
      left: 15px;
    }
  }
  .link {
    width: 100%;
    padding-right: 15px;
    display: block;
    overflow: hidden;
    -webkit-tap-highlight-color: transparent;
    .assert-t:after {
      margin-top: 0;
    }
  }
  .pre-wrap {
    width: 65px;
    height: 48px;
    float: left;
    -webkit-box-flex: 1;
    display: -webkit-box;
    -webkit-box-align: center;
  }
  .pre {
    position: relative;
    width: 65px;
    height: 50px;
    padding-left: 15px;
    line-height: 48px;
    font-size: 14px;
    color: #999;
    @apply --text-ellipsis;
  }
  .info-wrap {
    position: relative;
    width: 100%;
    padding-left: 65px;
    &:after {
      border-color: #ccc;
    }
  }
  .info {
    position: relative;
    width: 100%;
    padding: 11px 15px 11px 10px;
    & h4 {
      position: relative;
      width: 100%;
      display: block;
      overflow: hidden;
      padding-right: 10px;
      font-size: 14px;
      color: #333;
      font-weight: 400;
      line-height: 26px;
    }
  }
  .more {
    height: 40px;
    line-height: 40px;
    text-align: center;
    & a {
      display: block;
      color: var(--nine-color);
      font-size: 12px;
    }
    & span {
      padding-right: 15px;
      &:after {
        width: 6px;
        height: 6px;
        margin-top: -3px;
        border-color: var(--nine-color);
      }
    }
  }
  .liabilities-pic {
    padding: 0 15px 15px;
    .liab-img {
      position: relative;
      .zoom-in {
        z-index: 10;
        position: absolute;
        right: 15px;
        bottom: 15px;
        width: 24px;
        height: 24px;
        background: url(//img.winbaoxian.com/autoUpload/planbook/i-zoomIn_29926dcc8752e63.png)
          no-repeat center;
        background-size: 24px 24px;
        pointer-events: none;
      }
      > img {
        width: 100%;
        vertical-align: middle;
      }
    }
  }
  .original-link {
    > a {
      display: block;
      overflow: hidden;
      color: #999;
      font-size: 13px;
    }
    h6 {
      float: left;
      width: 52px;
      height: 46px;
      line-height: 46px;
    }
    .view {
      position: relative;
      width: 100%;
      padding-left: 52px;
      padding-right: 18px;
      text-align: right;
      line-height: 46px;
      &:after {
        width: 8px;
        height: 8px;
        right: 3px;
        margin-top: -3px;
        border-color: #ccc;
      }
    }
  }
  &.no-code {
    .pre-wrap {
      display: none;
    }
    .info-wrap {
      padding-left: 0;
    }
  }
}
</style>
